import { ActionButtonVariant } from '../../components/ActionButton/styled'
import { BannerTitleTextButtonProps } from '../../components/BannerTitleTextButton'
import { BannerTitleTextButtonVariant } from '../../components/BannerTitleTextButton/styled'
import { Classified } from '../../rest/types/Classified'
import { BlockCategory } from '../../forms/AdsForm/types'

export function bannerTitleTextButtonTransformer({
  t,
  isConnected,
  classified,
  onButtonClick,
}: {
  t: any
  isConnected: boolean
  classified?: Classified
  onButtonClick?: () => void
}): BannerTitleTextButtonProps | undefined {
  return {
    title: t('banner_title_text_button_title_interested_title'),
    text: t('banner_title_text_button_title_interested_text'),
    ...(onButtonClick && {
      button: {
        type: 'button',
        onClick: onButtonClick,
        text:
          isConnected ||
          classified?.classifiedCategory?.form === BlockCategory.OperatingAid
            ? t('banner_title_text_button_title_interested_button_text')
            : t('answer_classified_not_connected_button_text'),
        variant: ActionButtonVariant.quaternary,
      },
    }),
    variant: BannerTitleTextButtonVariant.secondary,
  }
}
